import { API } from '../services/API';
import { GET_USER_PATH } from '../services/paths';
import { ERROR } from '../utils/constants';
import { showMessage } from '../utils/messageUtils';
import { logout } from './authentication';
import { GET_USER, SET_TOKENS } from './types';

const setTokens = ({ accessToken }) => (dispatch) => dispatch({
	type: SET_TOKENS,
	accessToken
});

const getUser = () => (dispatch) => dispatch({
	type: GET_USER,
	promise: API.get(GET_USER_PATH),
	meta: {
		onSuccess: (response) => {
			const role = response.data.data.role;
			if (role == "overseer") {
				logout()
			}
		},
		onFailure: (error) => showMessage({ type: ERROR, msg: error?.response?.data?.error })
	}
});

export {
	setTokens,
	getUser
};
